import * as React from "react"
import CodeMirror from "@uiw/react-codemirror"
import { xml } from "@codemirror/lang-xml"
import { json } from "@codemirror/lang-json"
import { csharp } from "@replit/codemirror-lang-csharp"

import "./SourceCode.scss"
import bem from "../../bem"

declare let window: OldUIContext.TenForceWindow

interface Props {
    className?: string
    value: string
    lineNumbers: boolean
    readOnly: boolean
    onChange?: (value: string) => void
}

const b = bem.with("NewUI__sourceCode")

export default class SourceCode extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        lineNumbers: false,
        readOnly: false,
    }

    render(): JSX.Element {
        const { className, value, lineNumbers, readOnly } = this.props

        const extensions = [xml(), json(), csharp()]

        return (
            <div className={b("container") + (className || "")}>
                <CodeMirror
                    value={value}
                    onChange={this.onChange}
                    onCreateEditor={(editor, state): void => {
                        // expose the instance to allow for manipulating the content
                        // of the editor in integration tests
                        window.newUI.sourceCode = {
                            state,
                            editor,
                        }
                    }}
                    readOnly={readOnly}
                    basicSetup={{
                        lineNumbers,
                        syntaxHighlighting: true,
                    }}
                    extensions={extensions}
                />
            </div>
        )
    }

    onChange = (value: string): void => {
        const { onChange } = this.props
        onChange && onChange(value)
    }
}
